import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

export const holdEnvelope = async (envelopeId: string): Promise<void> => {
  await apiClient.post(`/v1/ecm/envelopes/${envelopeId}/hold`)
}

export const useHoldEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (envelopeId: string) => holdEnvelope(envelopeId),
    meta: {
      invalidatesQuery: ['envelopes', 'envelope', 'vault-items'],
      ...feedback,
    },
  })
}
